import React from "react"
import TextareaAutosize from "react-textarea-autosize"
import { useField } from "formik"
import { ArticleEditFormValues, ArticleTag } from "../../models/article"
import { nameof } from "../../utility/common/nameof"
import { useTranslation } from "react-i18next"
import cn from "classnames"
import styles from "./ArticleTags.module.scss"

const tNamespace = "knowledgeBase:article-edit-form."

export type ArticleTagsProps = {
    tags: ArticleTag[]
}

const ArticleTags = (props: ArticleTagsProps) => {
    const { tags } = props
    const value = tags.length ? `#${tags.join(" #")}` : ""

    return <div className={styles.tags}>{value}</div>
}

const FormikArticleTags: React.FC = () => {
    const [field, meta] = useField<string>(nameof<ArticleEditFormValues>("Tags"))
    const { t } = useTranslation()

    return (
        <TextareaAutosize
            onKeyPress={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                if (e.key === "Enter") e.preventDefault()
            }}
            id="article-tags"
            name={field.name}
            onChange={field.onChange}
            placeholder={`#${t(`${tNamespace}add-tag`)}`}
            className={cn(styles.tags, styles.tags__textarea, meta.touched && !!meta.error && styles.tags_isInvalid)}
            value={field.value}
            onBlur={field.onBlur}
        />
    )
}

export { ArticleTags, FormikArticleTags }
